import React, { useState } from "react";
import "./CopyFooter.css";

/**
 * CopyFooter — cədvəllərin altında vahid "seçilən" copy paneli
 * Props:
 *   value {string} — göstəriləcək mətn
 */
const CopyFooter = ({ value = "" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!value) return;
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="copy-footer">
      <span className="copy-footer__label">Seçilən:</span>
      <div className="copy-footer__input-group">
        <input
          type="text"
          className="copy-footer__input"
          readOnly
          value={value}
          placeholder="Xanaya klikləyin..."
        />
        {value && (
          copied
            ? <i className="bi bi-check-lg copy-footer__icon copy-footer__icon--done" />
            : <i className="bi bi-clipboard-plus copy-footer__icon" onClick={handleCopy} />
        )}
      </div>
    </div>
  );
};

export default CopyFooter;
